export default __webpack_public_path__ + "media/images/83-0c34a5d1a43a8e351a2896b8b25cb5fa.jpg";